// src/plugins/sweetalert-helper.js
import Swal from 'sweetalert2';

// 기본 SweetAlert2 옵션 설정 (선택 사항)
// 모든 알림에 공통적으로 적용될 기본값을 여기에 정의합니다.
const baseOptions = {
  confirmButtonColor: '#41b882', // Vue 초록색
  cancelButtonColor: '#ff7674',  // 약간 붉은색
  allowOutsideClick: false, // 기본적으로 외부 클릭으로 닫히지 않게 설정
  allowEscapeKey: false,    // 기본적으로 ESC 키로 닫히지 않게 설정
};

// 사용자 정의 SweetAlert2 헬퍼 객체
const harrisSwal = {
  // 일반 정보 알림
  info(title, text = '', options = {}) {
    return Swal.fire({
      ...baseOptions, // 기본 옵션
      icon: 'info',
      title: title,
      text: text,
      timer: 3000,
      ...options, // 개별 호출 시 전달하는 옵션으로 덮어쓰기
    });
  },

  // 성공 알림
  success(title, text = '', options = {}) {
    return Swal.fire({
      ...baseOptions,
      icon: 'success',
      title: title,
      text: text,
      timer: 3000,
      ...options,
    });
  },

  // 경고 알림
  warning(title, text = '', options = {}) {
    return Swal.fire({
      ...baseOptions,
      icon: 'warning',
      title: title,
      text: text,
      ...options,
    });
  },

  // 에러 알림
  error(title, text = '', options = {}) {
    return Swal.fire({
      ...baseOptions,
      icon: 'error',
      title: title,
      text: text,
      ...options,
    });
  },

  // 확인 (Confirm) 대화상자
  confirm(title, text = '', options = {}) {
    return Swal.fire({
      ...baseOptions,
      icon: 'question', // 확인은 보통 question 아이콘 사용
      title: title,
      text: text,
      showCancelButton: true, // 확인 대화상자는 기본적으로 취소 버튼 표시
      confirmButtonText: '확인',
      cancelButtonText: '취소',
      ...options,
    });
  },

  // 토스트 알림 (화면 상단/하단에 작게 나타났다 사라지는 알림)
  toast: {
    baseToastOptions: { // 토스트 전용 기본 옵션
      toast: true,
      position: 'top-end', // 오른쪽 상단
      showConfirmButton: false, // 토스트는 버튼 없음
      timer: 2000, // 3초 후 사라짐
      timerProgressBar: true,
    },
    info(title, options = {}) {
      return Swal.fire({
        icon: 'info',
        title: title,
        ...this.baseToastOptions,
        ...options,
      });
    },
    success(title, options = {}) {
      return Swal.fire({
        icon: 'success',
        title: title,
        ...this.baseToastOptions,
        ...options,
      });
    },
    warning(title, options = {}) {
      return Swal.fire({
        icon: 'warning',
        title: title,
        ...this.baseToastOptions,
        ...options,
      });
    },
    error(title, options = {}) {
      return Swal.fire({
        icon: 'error',
        title: title,
        ...this.baseToastOptions,
        ...options,
      });
    }
  },

  // 원본 SweetAlert2 인스턴스에 직접 접근해야 할 경우 (모든 기능을 활용)
  raw: Swal
};

// Vue 플러그인 형태로 내보내기
export default {
  install(Vue) {
    Vue.prototype.$s = harrisSwal;
  }
};